import React, { useRef } from 'react';
var VeltIf = function (props) {
    var condition = props.condition, children = props.children;
    var ref = useRef();
    return (React.createElement("velt-if", { ref: ref, condition: condition }, children));
};
export default VeltIf;
